import * as Yup from "yup";

// TODO: confirm your project imports yup as `import * as Yup` (most common).
// If your other schemas use a different style, match it here.

// accountType is required by the backend on every create — omitting it returns
// 400 (see spec v1.2). One of the standard double-entry classifications.
const ACCOUNT_TYPES = [
  "ASSET",
  "LIABILITY",
  "EQUITY",
  "INCOME",
  "EXPENSE",
  "INTERBANK",
];

export const createAccountSchema = Yup.object({
  accountNumber: Yup.string().trim().required("Account number is required"),
  accountName: Yup.string().trim().required("Account name is required"),
  accountType: Yup.string()
    .oneOf(ACCOUNT_TYPES, "Select a valid account type")
    .required("Account type is required"),
  currency: Yup.string().required("Currency is required"),
  // Auto-filled from the GL catalog; null when the account has no special
  // operational role. Optional so unmapped accounts still validate.
  role: Yup.string().nullable(),
});

export const postJournalSchema = Yup.object({
  debitAccountNumber: Yup.string().required("Debit account is required"),
  creditAccountNumber: Yup.string()
    .required("Credit account is required")
    .notOneOf(
      [Yup.ref("debitAccountNumber")],
      "Debit and credit accounts must differ",
    ),
  amount: Yup.number()
    .typeError("Amount must be a number")
    .positive("Amount must be greater than 0")
    .required("Amount is required"),
  narration: Yup.string().nullable(),
});
